<p class="green_witch_warp d_flex align_center">
    <span *ngIf="isLabelBefore==true" style="margin-right: 8px;" class="label font_16_a32_500">{{label}}</span>

    <label class="switch" [ngClass]="{disabled: disabled}">
        <input type="checkbox" [(ngModel)]="checked" (ngModelChange)="onToggleChange()">
        <span class="slider"></span>
    </label>
    <span *ngIf="isLabelBefore==false" class="label font_16_a32_500">{{label}}</span>
</p>